import useTranslation from 'next-translate/useTranslation';

// Components
import { PermanentEmptyState } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/PermanentEmptyState';

// Types
import type { PermanentEmptyStateProps } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/PermanentEmptyState';

type GroupEmptyStateProps = Pick<
    PermanentEmptyStateProps,
    'supportedNetworkTypes' | 'emptyStateName'
>;

export function GroupEmptyState({ emptyStateName, supportedNetworkTypes }: GroupEmptyStateProps) {
    const { t } = useTranslation('layout_platform');

    const title = emptyStateName
        ? t(`empty_states.groups.${emptyStateName}.title`)
        : t(`empty_states.groups.title`);

    const description = emptyStateName
        ? t(`empty_states.groups.${emptyStateName}.description`)
        : t(`empty_states.groups.description`);

    const displayEmptyStateUpVote = shouldDisplayEmptyStateUpVote(emptyStateName);

    return (
        <div data-testid="group-empty-state" className="flex-1">
            <PermanentEmptyState
                title={title}
                description={description}
                supportedNetworkTypes={supportedNetworkTypes}
                emptyStateName={emptyStateName}
                displayEmptyStateUpVote={displayEmptyStateUpVote}
            />
        </div>
    );
}

const shouldDisplayEmptyStateUpVote = (emptyStateName: string) => {
    const emptyStatesWithoutUpVote = [
        'publishing.scheduler.feed-preview',
        'conversations.mentions'
    ];
    return !emptyStatesWithoutUpVote.includes(emptyStateName);
};
